import {
  FETCH_EMAIL_SUGGESTIONS,
  GET_GROUP_EMAIL_RECIPIENTS,
  receiveEmailSuggestions,
  receiveGroupEmailRecipients,
  SEND_GROUP_EMAIL,
  UPDATE_GROUP_EMAIL_TYPE,
} from "@/components/email/ducks/Actions"
import {
  apiFetchEmailSuggestions,
  apiSendGroupEmail,
  getGroupEmailRecipients,
} from "@/components/email/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveGroupEmailRecipientsSuccess = (response) => {
    dispatch(receiveGroupEmailRecipients(response))
  }

  const receiveFetchSuggestionsSuccess = (response) => {
    dispatch(receiveEmailSuggestions(response.emails))
  }

  switch (action.type) {
    case SEND_GROUP_EMAIL: {
      apiSendGroupEmail(action.params, action.success, action.error)
      return next(action)
    }

    case UPDATE_GROUP_EMAIL_TYPE:
      getGroupEmailRecipients(action.params, receiveGroupEmailRecipientsSuccess, action.error)
      return next(action)

    case FETCH_EMAIL_SUGGESTIONS:
      apiFetchEmailSuggestions(action.query, receiveFetchSuggestionsSuccess)
      return next(action)

    case GET_GROUP_EMAIL_RECIPIENTS:
      getGroupEmailRecipients(action.params, receiveGroupEmailRecipientsSuccess, action.error)
      return next(action)

    default:
      return next(action)
  }
}
